module.exports = __webpack_public_path__ + "assets/img/24_423.288a3777.jpg";